/* eslint-disable @typescript-eslint/camelcase */
export enum UserTaskType {
  Registration_SalesRep_Review = 1,
  Registration_ChannelMgr_Review = 2,
  Registration_ChannelDir_Review = 4,
  Renewal_ChannelMgr_Review = 5
}